module.exports = __webpack_public_path__ + "img/ex14.c66c5fcf.png";